export const PARAM_MATCH_MODE = {
    like: 'like',
    equal: 'eq',
    notEqual: 'neq',
    in: 'in',
    startWith: 'startWith'
}
